import { BalanceByCycleDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { TimeBlocksBalanceCollection } from '../store/models/TimeBlocksBalanceCollection'

type Props = {
  employeeId: number
  cycleStartOn: string
  cycleEndOn: string
  skip: boolean
}

export const useFetchBankOfHours = ({ employeeId, cycleStartOn, cycleEndOn, skip }: Props) => {
  const { loading, data } = useQuery(BalanceByCycleDocument, {
    variables: { cycleStartOn, cycleEndOn, employeeId },
    skip,
    fetchPolicy: 'cache-first',
  })

  const aggregatedTimeBlocksBalance =
    data?.attendance.employee?.attendanceAggregatedBalanceConnection.nodes ?? []
  const timeBlocks = aggregatedTimeBlocksBalance.at(-1)
  const lastTimeBlock = new TimeBlocksBalanceCollection(timeBlocks)
  const bankOfHours = lastTimeBlock.balancePoolMinutes

  return {
    bankOfHours,
    isLoading: loading,
  }
}
